// extracted by mini-css-extract-plugin
export var dropdown = "_sb-0";
export var imageWrapper = "_sb-3";
export var itemNameContainer = "_sb-1";
export var productImage = "_sb-2";
export var spinnerWrapper = "_sb-4";